import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { LOG_IN_ROUTE } from '@shared/common/constants';

export const authGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const auth = inject(AuthService);
  if (!auth.isAuthenticated()) {
    return new RedirectCommand(router.parseUrl(LOG_IN_ROUTE), {
      state: { redirectUrl: state.url },
    });
  }
  return true;
};
